/**
 * Подключается в компоненте прямо в функции/объекте head после других настоек link/meta
 * Сделано чтоб не перезаписывались head тэги функцией компнента.
 * Если в компоненте не объявлен head то нужно использовать просто mixin
 * Подключается через apply чтоб был доступен контекст
 *
 * head(){
 *    ...link.apply(this, [{ exclude:[] }])
 * }
 *
 * @param {Array} exclude Удалит подстроки исходного пути для canonical ссылки
 * @returns Вернёт объект для подключения head в магазине
 */

import type { ComponentRenderProxy } from '@nuxtjs/composition-api'

export function link(this: ComponentRenderProxy, { exclude }: { exclude?: string[] } = {}) {
  const path = excluder({ origin: this.$route.path, exclude })

  return {
    link: [
      {
        hid: 'canonical',
        rel: 'canonical',
        href: `${this.$config.projectURL + path}`,
      },
    ],
  }
}

/**
 * Базовый объект миксина. В большинстве случаев будет достаточно
 * вызвать его в массиве mixins компонента.
 * Если в компоненте используется head запись надо использовать функцию link
 *
 * @param {Array} exclude Удалит подстроки исходного пути для canonical ссылки
 * @returns Вернёт объект миксина
 */

export function mixin({ exclude }: { exclude?: string[] } = {}) {
  return {
    head(this: ComponentRenderProxy) {
      return link.apply(this, [{ exclude }])
    },
  }
}

/**
 * Функция помощник. Если строка заканчивается на элемент в массиве exlude удалит подстроку
 * Возвращает новое значение origin
 *
 * @param {Array} exclude Подстроки
 * @param {String} origin Оригинальная строка
 * @returns Вернёт объект миксина
 */

export function excluder({ exclude, origin }: { exclude?: string[]; origin: string }) {
  if (!exclude && !Array.isArray(exclude))
    return origin

  let res = origin

  exclude.forEach((item) => {
    if (origin.endsWith(item) && res)

      res = res.replace(new RegExp(`${item}\/?$`, 'gi'), '')
  })

  return res
}
